import React from 'react';

const ImageLoading = () => (
  <div className="col-md-4 col-ms-6" style={{ marginTop: 20 }}>
    <div className="loading" style={{ width: 300, height: 185 }} />
  </div>
);

export default ImageLoading;
